import "./BusinessAnalysis.css";
import { Link } from "react-router-dom";
import {
  MdPeople,
  MdAccountBox,
  MdOutlineLibraryAdd,
  MdOutlineViewList,
  MdContactMail,
  MdAttachMoney,
  MdCategory,
  MdPostAdd,
  MdList,
  MdAddBox,
  MdLocalActivity,
  MdHealthAndSafety,
  MdDirectionsBike,
  MdRemoveRedEye,
  MdAgriculture,
  MdSportsKabaddi,
  // New icons for Mbbs Duniya
  MdSchool,
  MdMessage,
  MdAttachMoney as MdCutoff,
  MdGroup,
  MdBusiness,
  MdLocationCity,
  //   MdContactSupport,
  MdContactSupport,
  MdMoneyOff,
  MdPersonAdd,
  MdStore,
  MdApartment,
  MdChat,
  MdCardMembership,
} from "react-icons/md";

const BusinessAnalysis = () => {
  const dashboardItems = [
    // {
    //     category: "LSSF Management",
    //     items: [
    //         {
    //             title: "Sewing Applications",
    //             quantity: "0",
    //             icon: <MdAccountBox size={32} />,
    //             href: "/dashboard/lssf/sewing-applications",
    //             color: "#FFA07A"
    //         },
    //         {
    //             title: "Health Camp Applications",
    //             quantity: "0",
    //             icon: <MdHealthAndSafety size={32} />,
    //             href: "/dashboard/lssf/health-applications",
    //             color: "#98D8C8"
    //         },
    //         {
    //             title: "Tricycle Applications",
    //             quantity: "0",
    //             icon: <MdDirectionsBike size={32} />,
    //             href: "/dashboard/lssf/tricycle-applications",
    //             color: "#F7D794"
    //         },
    //         {
    //             title: "Cataract Applications",
    //             quantity: "0",
    //             icon: <MdRemoveRedEye size={32} />,
    //             href: "/dashboard/lssf/cataract-applications",
    //             color: "#F8A5C2"
    //         },
    //         {
    //             title: "Farmer Applications",
    //             quantity: "0",
    //             icon: <MdAgriculture size={32} />,
    //             href: "/dashboard/lssf/farmer-applications",
    //             color: "#63CDDA"
    //         },
    //         {
    //             title: "Running Competition",
    //             quantity: "0",
    //             icon: <MdSportsKabaddi size={32} />,
    //             href: "/dashboard/lssf/running-competition",
    //             color: "#EA868F"
    //         },
    //         {
    //             title: "Contact Enquiries",
    //             quantity: "0",
    //             icon: <MdContactMail size={32} />,
    //             href: "/dashboard/lssf/contact-enquiries",
    //             color: "#A8D8EA"
    //         },
    //         {
    //             title: "Donations",
    //             quantity: "0",
    //             icon: <MdAttachMoney size={32} />,
    //             href: "/dashboard/lssf/donations",
    //             color: "#FFD93D"
    //         }
    //     ]
    // },
    {
      category: "Mbbs Duniya Mgmt",
      items: [
        // {
        //   title: "Counseling Details",
        //   icon: <MdContactSupport size={20} />,
        //   href: "/dashboard/mbbs/counseling-details",
        //   color: "#4A90E2",
        //   description: "Manage counseling sessions",
        // },
        {
          title: "International Colleges",
          icon: <MdContactSupport size={20} />,
          href: "/dashboard/mbbs/international-colleges",
          color: "#4A90E2",
          description: "Manage counseling sessions",
        },
        {
          title: "Contact Messages",
          icon: <MdChat size={20} />,
          href: "/dashboard/mbbs/contact-enquiry",
          color: "#50E3C2",
          description: "Student inquiries",
        },
        // {
        //   title: "Payment History",
        //   icon: <MdMoneyOff size={20} />,
        //   href: "/dashboard/mbbs/payment-history",
        //   color: "#F5A623",
        //   description: "Cutoff purchase records",
        // },
        {
          title: "Registered Students",
          icon: <MdGroup size={20} />,
          href: "/dashboard/mbbs/students-list",
          color: "#D0029B",
          description: "All registered students",
        },
        {
          title: "College List",
          icon: <MdBusiness size={20} />,
          href: "/dashboard/mbbs/college-list",
          color: "#8B572A",
          description: "Medical colleges database",
        },
        {
          title: "Create Blog",
          icon: <MdLocationCity size={20} />,
          href: "/dashboard/mbbs/blogs/create",
          color: "#417505",
          description: "Cities with colleges",
        },
        {
          title: "Blog List",
          icon: <MdLocationCity size={20} />,
          href: "/dashboard/mbbs/blogs",
          color: "#417505",
          description: "Cities with colleges",
        },
        {
          title: "Testimonials",
          icon: <MdChat size={20} />,
          href: "/dashboard/mbbs/testimonials",
          color: "#417505",
          description: "Cities with colleges",
        },
                {
          title: "Counselling Leads",
          icon: <MdChat size={20} />,
          href: "/dashboard/mbbs/leads",
          color: "#417505",
          description: "Cities with colleges",
        },
                        {
          title: "Subscriptions",
          icon: <MdCardMembership size={20} />,
          href: "/dashboard/mbbs/subscriptions",
          color: "#417505",
          description: "Cities with colleges",
        },
      ],
    },
  ];
 
  return (
    <div className="page-wrapper">
      <div className="container-fluid">
        <div className="row">
          <div className="col-12">
            <div className="welcome-card mb-4">
              <h4 className="mb-2">Welcome to Dashboard</h4>
              <p className="text-light">
                Manage all your applications, content, and MBBS Duniya resources
              </p>
            </div>
          </div>
        </div>

        {dashboardItems.map((section, sectionIndex) => (
          <div key={sectionIndex} className="card mb-4">
            <div className="card-header bg-white">
              <h5 className="mb-0">
                {section.category === "LSSF Management" ? (
                  <MdPeople size={24} className="me-2" />
                ) : (
                  <MdSchool size={24} className="me-2" />
                )}
                {section.category}
              </h5>
            </div>
            <div className="card-body">
              <div className="row">
                {section.items.map((item, itemIndex) => (
                  <div className="col-md-3 col-sm-6 mb-4" key={itemIndex}>
                    <Link to={item.href} className="text-decoration-none">
                      <div className="dashboard-card shadow-sm">
                        <div
                          className="card-icon"
                          style={{ color: item.color }}
                        >
                          {item.icon}
                        </div>
                        <div className="card-content">
                          <h6 className="card-title mb-2">{item.title}</h6>
                        </div>
                        <div className="card-hover-effect"></div>
                      </div>
                    </Link>
                  </div>
                ))}
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default BusinessAnalysis;
